import React from "react";
import Gen8RecruitmentPage from "./seasons/gen8";

/**
 * Main recruitment landing page.
 * Points to the latest or current generation recruitment cycle.
 */
const RecruitmentPage: React.FC = () => {
  return <Gen8RecruitmentPage />;
};

export default RecruitmentPage;
